import "../../pages/new/new.scss"

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axiosInstance from '../../api/axios';
import { getAllThesis, getFeedbackById } from '../../services/thesisService';
import { getExaminers } from '../../services/instructorService';
import { getReviewers } from '../../services/instructorService';
import { getAllStudents } from '../../services/studentService';
import { getAllSubmissions1 } from '../../services/submissionService';
import { toast } from 'react-toastify';
import { jwtDecode } from "jwt-decode";
import TextBox from './TextBox';
//import "./Feedback.scss";




export const AddFeedback = () => {
    const examinerId = parseInt(localStorage.getItem('examinerId'), 10);
    const studentLoginId = parseInt(localStorage.getItem('studentId'), 10);
    //const reviewerLoginId = parseInt(localStorage.getItem('reviewerId'), 10);
    const { feedbackId } = useParams();
    const { studentId } = useParams();
    const [thesis, setThesis] = useState([]);
    const [students, setStudents] = useState([]);
    const [submissions, setSubmissions] = useState([]);
    const [selectedStudentId, setSelectedStudentId] = useState(null);
    const [feedback, setFeedback] = useState({
        thesisId: '',
        title: '',
        studentId: '',
        studentName: '',
        enrollmentNumber: '',
        mentor1Name: '',
        mentor2Name: '',
        examinerName: '',
        overallFeedback: '',
        presentationFeedback: '',
        reportFeedback: '',
        otherFeedback: '',
        type: '',
        problemStmt: '',
        literatureSurvey: '',
        methodology: '',
        results: '',
        conclusionFuturework: '',
        presentation: '',

        gradeProposedProblem: null,
        gradeProposedSolution: null,
        gradeProblemUnderstanding: null,
        gradeAcademicRigour: null,
        gradeWorkQuantum: null,
        gradeOverall: null,
        thesisStatusId: '',
        problemSolved: '',

        gradeConclusionFuturework: null,
        gradeResults: null,
        gradeMethodology: null,
        gradeLiteratureSurvey: null,

        presentationMarks: '',
        vivaMarks: '',
        reportMarks: '',
        date_submitted: ''
    
    });

    const location = useLocation();

const from = location.state?.from || "/default-page";  // fallback page
    const [examiners, setExaminers] = useState([]);
    const [selectedExaminerId, setSelectedExaminerId] = useState(null);
    const [examinerFeedbacks, setExaminerFeedbacks] = useState([]);
    const [reviewers, setReviewers] = useState([]);
    const [selectedReportType, setSelectedReportType] = useState(null);
    const [selectedThesisId, setSelectedThesisId] = useState(null);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [editMode, setEditMode] = useState(false);
    const [viewMode, setViewMode] = useState(false);
    const token = localStorage.getItem('token'); 
    const decoded = jwtDecode(token);
    const userRole = decoded.roles;

    const [thesisStatusId, setThesisStatusId] = useState(null);

    const [fileLinks, setFileLinks] = useState({});
        
    const [uploadedFiles, setUploadedFiles] = useState({});

    const [linksLoaded, setLinksLoaded] = useState(false);
        
    const reportUploaded = uploadedFiles?.Report;
    const presentationUploaded = uploadedFiles?.Presentation_File;
    const presentationVideoUploaded = uploadedFiles?.Presentation_Video;
    const turnitinUploaded = uploadedFiles?.Turnitin;
    const rebuttalUploaded = uploadedFiles?.Rebuttal_Report_File;
    const codeDemoUploaded = uploadedFiles?.Code_Demo_File;
    const [aiSummaryLink, setAiSummaryLink] = useState(null);
    const statusLabelMap = {
    WORK_IN_PROGRESS: "End Term",
    REPORT_REVISION_REQUIRED: "Revised Report",
    RESUBMISSION: "End Term Resubmission"
};
    const fetchThesis = async () => {
        try {
            const data = await getAllThesis();
           // console.log(data);
            setThesis(data.data);
        } catch (err) {

        }
    };
    const fetchThesisStatusById = async (studentId) => {
        try {
            const data = await getAllSubmissions1(studentId);
            //console.log(data.data);
            setSubmissions(data.data);
            return data.data;
        } catch (err) {

        }
    };

    const fetchStudents = async () => {
        try {
            const data = await getAllStudents();
          //  console.log(data);
            setStudents(data.data);
        } catch (err) {

        }
    };

    const fetchExaminerFeedbacks = async (studentId) => {
        try {
            const response = await axiosInstance.get(
            `/thesisFeedbacks?id=${studentId}&isView=false`
            );
            const data = response.data.data;
            const filtered = data.filter( (exam) => (exam.is_examiner || exam.is_reviewer) && exam.thesis_status_id !== Number(feedback.thesisStatusId) && exam.date_submitted < feedback.date_submitted );           
           
         //   const filtered = data.filter( (exam) => exam.is_examiner && exam.thesis_status_id !== feedback.thesisStatusId && 
         //   ((feedback.type === 'Phase3' && (exam.report_type === 'Phase3' || exam.report_type === 'Phase2' ||exam.report_type === 'Phase1' || exam.report_type === 'ResearchProposal'))
         //   || (feedback.type === 'Phase2' && (exam.report_type === 'Phase2' || exam.report_type === 'Phase1' || exam.report_type === 'ResearchProposal')) 
         //   || (feedback.type === 'Phase1' && (exam.report_type === 'Phase1' || exam.report_type === 'ResearchProposal')) 
         //   || (exam.report_type === 'ResearchProposal' && feedback.type === 'ResearchProposal')));
          //   console.log("Data:", data);
         //   console.log("Filtered:", filtered);
          //  console.log(feedback.thesisStatusId, feedback.reportType, feedback.dateSubmitted);
            const grouped = filtered.reduce((acc, item) => {
            const key = item.report_type + "_" + item.term_type;


            if (!acc[key]) {
                acc[key] = {
                    report_type: item.report_type,
                    term_type: item.term_type,
                    thesis_viva_status: item.thesisVivaStatus,
                    report_link: item.report_link,
                    feedbacks: []
                };
            }

            acc[key].feedbacks.push(item);
            return acc;
        }, {});

        // convert to array
        setExaminerFeedbacks(Object.values(grouped));
        setThesisStatusId(response.data.thesis_status_id);

        //console.log("Grouped Add Feedback:", Object.values(grouped));
         //   setExaminerFeedbacks(filtered); 
        // console.log("Add feedback data", data);
          // console.log(feedback.thesisStatusId)
        } catch (error) {
            console.error("Error fetching examiner feedbacks:", error);
        }
        }; 

  /*      const fetchExaminerFeedbacks = async (studentId) => {
    try {
        const response = await axiosInstance.get(
            `/thesisFeedbacks?id=${studentId}&isView=false`
        );

        const data = response.data.data;

        const filteredFeedbacks = data.filter(
    (exam) =>
        exam.is_examiner &&
        (
            exam.report_type !== feedback.type ||
            (exam.report_type === feedback.type && exam.share_to_student === true)
        )
);

        const grouped = filtered.reduce((acc, item) => {
            const key = item.report_type + "_" + item.term_type;

            if (!acc[key]) {
                acc[key] = {
                    report_type: item.report_type,
                    term_type: item.term_type,
                    feedbacks: []
                };
            }

            acc[key].feedbacks.push(item);
            return acc;
        }, {});

        // convert to array
        setExaminerFeedbacks(Object.values(grouped));

        console.log("Grouped:", Object.values(grouped));

    } catch (error) {
        console.error("Error fetching examiner feedbacks:", error);
    }
}; */


        useEffect(() => {
                if (feedback.studentId) {
                    fetchExaminerFeedbacks(feedback.studentId);
                }
                }, [feedback.studentId]);
    
    const findElementByIdWithReduce = (array, id) => {
      //  console.log(array);
       // console.log(id);
        return array.reduce((acc, element) => {
            return element.id === id ? element : acc;
        }, null);
    };
    const findStudentByEnWithReduce = (array, id) => {
      //  console.log(array);
      //  console.log(id);
        return array.reduce((acc, element) => {
            return element.enrollmentNumber === id ? element : acc;
        }, null);
    };

    const findSubmissionsByReportTypeWithReduce = (array, reportType) => {
        return array.reduce((acc, element) => {
            return element.submission_id == reportType ? element : acc;
        }, null);
    };
    const fetchFeedback = async (id) => {
        try {
            const response = await getFeedbackById(id);
           // console.log(response.data)
            setFeedback(response.data);
            setSelectedReportType(response.data.reportType);
            setSubmissions([{
                report_type: response.data.reportType,
                term_type: response.data.termType,
                abstract: response.data.thesisAbstract,
                id: response.data.thesisStatusId,
                submission_id: response.data.thesisStatusId,
                term_thesis_status: response.data.termThesisStatus,
                attempt_number: response.data.attemptNumber
            }
            ]
            );
            setSelectedStudentId(response.data.enrollmentNumber);
            //console.log(thesis);
            //console.log(findElementByIdWithReduce(thesis, response.data.thesisId));
            //setSelectedThesisId(findElementByIdWithReduce(thesis, response.data.thesisId));
            // Set course details from API response
            setSelectedExaminerId(response.data.examinerId);
            setThesisStatusId(response.data.thesisStatusId);
            if (response.data.ai_summary_exists) {
                try {
                    const res = await axiosInstance.get(
                        "/files/presign-download-aiSummary",
                        {
                            params: {
                                thesisStatusId:response.data.thesisStatusId,
                                fileType: "Ai_Summary"
                            }
                        }
                    );

                    setAiSummaryLink(res.data?.data?.downloadUrl);
                } catch{
                }
            }
        } catch (error) {
            console.error('Error fetching course:', error);
        }
    };
    const fetchExaminerList = async () => {
        try {
            const response = await getExaminers();
            //console.log(response.data)

            const response1 = await getReviewers();
            //console.log(response1.data)
            setReviewers(response1.data);
            const mergedData = [...response.data, ...response1.data];
            setExaminers(mergedData);

            // Set course details from API response
        } catch (error) {
            console.error('Error fetching course:', error);
        }
    };
    useEffect(() => {
        //fetchThesis();
        if(!studentLoginId){
            fetchStudents();        
            fetchExaminerList();
 
        }
           }, []);
    useEffect(() => {
        if (feedbackId) {
            const path = location.pathname; 

            if (path.includes('edit-feedback')) {
                setEditMode(true);
                setViewMode(false); 
            } 
            else if (path.includes('view-feedback')) {
                setViewMode(true);
                setEditMode(false); 
            }

            setFileLinks({});
            setLinksLoaded(false);
            setUploadedFiles({});

            fetchFeedback(feedbackId);
            // Set mode to edit if courseId is present
        } else {
            setEditMode(false);
            setViewMode(false);
        }
    }, [feedbackId, location.pathname]); 

    useEffect(() => {
        if (!thesisStatusId) return;

        const fetchAllFileData = async () => {
            try {
            const statusRes = await axiosInstance.get(`/files/status/${thesisStatusId}`);
            const uploaded = statusRes.data.data || {};

            setUploadedFiles(uploaded);

            const newLinks = {};

            for (const type in uploaded) {
                if (!uploaded[type]) continue;

                try {
                const res = await axiosInstance.get("/files/presign-download", {
                    params: { thesisStatusId, fileType: type }
                });

                newLinks[type] = {
                    url: res.data.data.downloadUrl,
                    originalFilename: res.data.data.originalFilename
                };
                } catch (e) {
                console.error(`Failed for ${type}`, e);
                }
            }

            setFileLinks(newLinks);
            setLinksLoaded(true);

            } catch (err) {
            console.error("Error fetching file data", err);
            setLinksLoaded(true);
            }
        };

        setFileLinks({});
        setLinksLoaded(false);
        setUploadedFiles({});

        fetchAllFileData();

        }, [thesisStatusId]);

//     useEffect(() => {
//     if (!thesisStatusId) return;

//     axiosInstance
//       .get(`/files/status/${thesisStatusId}`)
//       .then(res => setUploadedFiles(res.data.data))
//       .catch(console.error);

//   }, [thesisStatusId]);

    const handleThesisSelect = (event) => {
        const selectedJson = JSON.parse(event.target.value);
        setFeedback(feedback => ({
            ...feedback,
            studentId: selectedJson.student_id,
            studentName: selectedJson.student_name,
            thesisId: selectedJson.id
        }));

      //  console.log(feedback);
      //  console.log(event.target.value);
    };

    const handleAddExaminerSelect = (event) => {
        setSelectedExaminerId(event.target.value);
    };

    const handleReportChange = (event) => {
        if (event.target.value !== '') {
            var submission = findSubmissionsByReportTypeWithReduce(submissions, event.target.value);
            setSelectedReportType(event.target.value);
           // console.log(submission);
            setFeedback(feedback => ({
                ...feedback,
                title: submission.title,
                abstract: submission.abstract,
                reportType: submission.report_type,
                termType: submission.term_type,
                mentor1Name: submission.mentor1_name,
                mentor2Name: submission.mentor2_name,
                reportLink: submission.report_link,
                folderLink: submission.folder_link,
                presentationLink: submission.presentation_link,
                presentationVideoLink: submission.presentation_video_link,
                rebuttalReportLink: submission.rebuttal_report_link,
                turnitin: submission.turnitin,
                reportMonth:submission.report_month,
                thesisStatusId: submission.submission_id,
                type: submission.report_type,
            }));
        }
        else {
            setSelectedReportType(null);
            setFeedback(feedback => ({
                ...feedback,
                reportType: '',
                reportMonth:'',
                title: '',
                mentor1Name: '',
                mentor2Name: '',
                reportLink: '',
                folderLink: '',
                presentationLink: '',
                presentationVideoLink:'',
                turnitin: '',
                rebuttalReportLink: '',
                thesisStatusId: ''


            }));
        }


    }
    const handleStudentChange = async (event) => {

        if (event.target.value !== '') {
            var student = findStudentByEnWithReduce(students, event.target.value);
            var data = await fetchThesisStatusById(student.id);
           // console.log(data);
            if (data.length === 0) {
                setSelectedStudentId(null);
                setSubmissions([]);
                setFeedback(feedback => ({
                    ...feedback,
                    studentId: '',
                    enrollmentNumber: '',
                    studentName: '',
                    thesisId: '',
                    title: '',
                    abstract: '',
                    mentor1Name: '',
                    mentor2Name: '',
                    reportLink: '',
                    folderLink: '',
                    presentationLink: '',
                    presentationVideoLink:'',
                    turnitin: '',
                    rebuttalReportLink: '',
                    thesisStatusId: '',
                    reportType: '',
                    reportMonth:''
                }));
                toast.error('Student does not have submissions yet. Select another student');

                return;
            }
            else {
                setSelectedStudentId(event.target.value);
                setFeedback(feedback => ({
                    ...feedback,
                    studentId: student.id,
                    studentName: student.name,
                    enrollmentNumber: event.target.value

                }));
            }
        }
        else {
            setSelectedStudentId(null);
            setSubmissions([]);
            setFeedback(feedback => ({
                ...feedback,
                studentId: '',
                studentName: '',
                thesisId: '',
                title: '',
                mentor1Name: '',
                mentor2Name: '',
                reportLink: '',
                folderLink: '',
                presentationLink: '',
                presentationVideoLink:'',
                turnitin: '',
                rebuttalReportLink: '',
                thesisStatusId: '',
                reportType: '',
                reportMonth:''
            }));
        }


    };

    const goBack = (e) => {
       // console.log(feedbackId);
      //  console.log(studentId);
        const path = window.location.pathname;
      //  console.log(path);
        if (examinerId && studentId)
            navigate(`/examiner/view-feedbacks/${studentId}`);
        else if(studentLoginId)
            navigate(`/student/feedbacks`);
        else if (studentId)
            navigate(`/students/edit-student/${studentId}`);
        else
            navigate('/feedbacks');
    };

    const validateForm = () => {
        const errors = {};
        if (!feedback.studentId) {
            errors.student = 'Student is required';
        }
        if (!feedback.type) {
            errors.type = 'Feedback type is required';
        }
        if (!feedback.reportType) {
            errors.reportType = 'Report type is required';
        }
        if (!selectedExaminerId) {
            errors.examiner = 'examiner is required';
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleClick = (e) => {
       // console.log("inside handle click")
        if(e.target.value)
        window.open(e.target.value, '_blank');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFeedback({ ...feedback, [name]: value || '' });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
       // console.log("inside submit");
        var response = '';
        try {
            if (viewMode) {
                navigate('/feedbacks');
            }


            else if (editMode) {
              // console.log(feedbackId);
                var editFeedback = {
                    id: feedbackId,
                    studentId: feedback.studentId,
                    examinerId: selectedExaminerId,
                    thesisStatusId: feedback.thesisStatusId,
                    month: feedback.month,
                    year: feedback.year,
                    overallFeedback: feedback.overallFeedback,
                    presentationFeedback: feedback.presentationFeedback,
                    reportFeedback: feedback.reportFeedback,
                    otherFeedback: feedback.otherFeedback,
                    type: feedback.type,
                    problemStmt: feedback.problemStmt,
                    literatureSurvey: feedback.literatureSurvey,
                    methodology: feedback.methodology,
                    results: feedback.results,
                    conclusionFuturework: feedback.conclusionFuturework,
                    presentation: feedback.presentation,

                    gradeProposedProblem: feedback.gradeProposedProblem,
                    gradeProposedSolution: feedback.gradeProposedSolution,
                    gradeProblemUnderstanding: feedback.gradeProblemUnderstanding,
                    gradeAcademicRigour: feedback.gradeAcademicRigour,
                    gradeWorkQuantum: feedback.gradeWorkQuantum,
                    gradeOverall: feedback.gradeOverall || null,
                    problemSolved: feedback.problemSolved,

                    gradeConclusionFuturework: feedback.gradeConclusionFuturework,
                    gradeResults: feedback.gradeResults,
                    gradeMethodology: feedback.gradeMethodology,
                    gradeLiteratureSurvey: feedback.gradeLiteratureSurvey,

                    presentationMarks: feedback.presentationMarks,
                    vivaMarks: feedback.vivaMarks,
                    reportMarks: feedback.reportMarks


                }
                // Update course if in edit mode
                response = await axiosInstance.put('/feedbacks', editFeedback, { showToastOnResponse: true });
            }
            else {
               // console.log(feedback);
                var addFeedback = {
                    studentId: feedback.studentId,
                    examinerId: selectedExaminerId,
                    thesisStatusId: feedback.thesisStatusId,
                    month: feedback.month,
                    year: feedback.year,
                    overallFeedback: feedback.overallFeedback,
                    presentationFeedback: feedback.presentationFeedback,
                    reportFeedback: feedback.reportFeedback,
                    otherFeedback: feedback.otherFeedback,
                    type: feedback.type,
                    problemStmt: feedback.problemStmt,
                    literatureSurvey: feedback.literatureSurvey,
                    methodology: feedback.methodology,
                    results: feedback.results,
                    conclusionFuturework: feedback.conclusionFuturework,
                    presentation: feedback.presentation,

                    gradeProposedProblem: feedback.gradeProposedProblem,
                    gradeProposedSolution: feedback.gradeProposedSolution,
                    gradeProblemUnderstanding: feedback.gradeProblemUnderstanding,
                    gradeAcademicRigour: feedback.gradeAcademicRigour,
                    gradeWorkQuantum: feedback.gradeWorkQuantum,
                    gradeOverall: feedback.gradeOverall || null,
                    problemSolved: feedback.problemSolved,

                    gradeConclusionFuturework: feedback.gradeConclusionFuturework,
                    gradeResults: feedback.gradeResults,
                    gradeMethodology: feedback.gradeMethodology,
                    gradeLiteratureSurvey: feedback.gradeLiteratureSurvey,
                    presentationMarks: feedback.presentationMarks,
                    vivaMarks: feedback.vivaMarks,
                    reportMarks: feedback.reportMarks

                }


                response = await axiosInstance.post('/feedbacks', addFeedback, { showToastOnResponse: true });

            }
           // console.log(response);
            //navigate('/feedbacks');
            navigate(from);

        } catch (error) {
            console.log('Error saving feedback. Please try again later.');
            console.log(error);
        }
    };

    const fetchFileLink = async (fileType) => {
        try {
          const res = await axiosInstance.get("/files/presign-download", {
            params: {
              thesisStatusId,
              fileType
            }
          });

          setFileLinks(prev => ({
            ...prev,
            [fileType]: {
              url: res.data.data.downloadUrl,
              originalFilename: res.data.data.originalFilename
            }
          }));
        } catch (e) {
          console.error(`Failed to fetch ${fileType}`, e);
        }
      };

    //   useEffect(() => {
    //       if (!thesisStatusId) return;
      
    //       if (reportUploaded) fetchFileLink("Report");
    //       if (presentationUploaded) fetchFileLink("Presentation_File");
    //       if (presentationVideoUploaded) fetchFileLink("Presentation_Video");
    //       if (turnitinUploaded) fetchFileLink("Turnitin");
    //       if (rebuttalUploaded) fetchFileLink("Rebuttal_Report_File");
    //       if (codeDemoUploaded) fetchFileLink("Code_Demo_File");
      
    //     }, [
    //       thesisStatusId,
    //       reportUploaded,
    //       presentationUploaded,
    //       presentationVideoUploaded,
    //       turnitinUploaded,
    //       rebuttalUploaded,
    //       codeDemoUploaded
    //     ]);

      const isDriveLink = (value) =>
        typeof value === "string" && value.startsWith("http");

    return (
        <div>
            <div className="top">
                <h1>{editMode ? 'Edit Feedback' : viewMode ? 'View Feedback' : 'Add Feedback'}</h1>
            </div>
            <div className="bottom">
                <div className="left"></div>
                <div className="right">
                    <form onSubmit={handleSubmit}>
                    {!studentLoginId && <div className="formInput">
                            <label>Student Enrollment Number</label>
                            
                            <select onChange={handleStudentChange}
                                disabled={viewMode || editMode}
                                name="student"
                                value={selectedStudentId}

                            >

                                <option value="">Select a Student Enrollment Number</option>
                                {students && students.map(option => (
                                    <option key={option.enrollmentNumber} value={option.enrollmentNumber}>
                                        {option.enrollmentNumber}
                                    </option>
                                ))}

                            </select>
                            {errors.student && <div className="error-text">{errors.student}</div>}
                        </div>}
                        {!studentLoginId && <div className="formInput">
                            <label>Student Name</label>
                            
                            <input type="text"
                                name="studentName"
                                value={feedback.studentName}
                                disabled={true}
                                className={errors.studentName ? 'error' : ''} />
                            {errors.studentName && <div className="error-text">{errors.studentName}</div>}
                        </div>}

                       {/*
                        <div className="formInput">
                            <label>Report Type</label>
                            <select onChange={handleReportChange}
                                name="reportType"
                                value={feedback.thesisStatusId}
                                disabled={viewMode || editMode}
                                className={errors.reportType ? 'error' : ''}                          >

                                <option value="">Select report type</option>
                                {submissions && submissions.map(option => (
                                    <option key={option.id} value={option.submission_id}>
                                        {option.report_type}
                                    </option>
                                ))}

                            </select>
                            {errors.reportType && <div className="error-text">{errors.reportType}</div>}
                        </div>

                        <div className="formInput">
                            <label>Submission Type</label>
                            <select onChange={handleReportChange}
                                name="termThesisStatus"
                                value={feedback.thesisStatusId}
                                disabled={viewMode || editMode}
                                className={errors.termThesisStatus ? 'error' : ''}                          >

                                <option value="">Select submission type</option>
                                {submissions && submissions.map(option => (
                                    <option key={option.id} value={option.submission_id}>
                                        {statusLabelMap[option.term_thesis_status] || option.term_thesis_status}
                                    </option>
                                ))}

                            </select>
                            {errors.reportType && <div className="error-text">{errors.reportType}</div>}
                        </div> */}

                       {/* <div className="formInput">
                            <label>Submission Count</label>
                            <select onChange={handleReportChange}
                                name="attemptNumber"
                                value={feedback.thesisStatusId}
                                disabled={viewMode || editMode}
                                className={errors.reportType ? 'error' : ''}                          >

                                <option value="">Select</option>
                                {submissions && submissions.map(option => (
                                    <option key={option.id} value={option.submission_id}>
                                        {option.attempt_number}
                                    </option>
                                ))}

                            </select>
                            {errors.reportType && <div className="error-text">{errors.reportType}</div>}
                        </div> */}
{feedback.reportType == "Monthly" &&
    <div className="formInput">
    <label>Report Month</label>
    <input type="text"
        name="reportMonth"
        value={feedback.reportMonth}
        readOnly
        className={errors.reportMonth ? 'error' : ''} />
    {errors.reportMonth && <div className="error-text">{errors.reportMonth}</div>}
</div>
}

                        <div className="formInput">
                            <label>Thesis Title</label>
                            <TextBox type="text"
                                name="title"
                                value={feedback.title}
                                disabled={true}
                                className={errors.title ? 'error' : ''} />
                            {errors.title && <div className="error-text">{errors.title}</div>}
                        </div>
                        <div className="Monthly">
                            <div className="monthlyInput">
                                <label>Thesis Abstract</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="abstract"
                                    value={feedback.thesisAbstract}
                                    readOnly={true}
                                    onChange={handleChange}
                                    className={errors.abstract ? 'error' : ''} />
                                {errors.abstract && <div className="error-text">{errors.abstract}</div>}
                            </div>
                        </div>
                        {/*<div className="formInput"> 

                            <div className="formInput">
                            <label>Mentor1</label>
                            <input type="text"
                                name="mentor1Name"
                                value={feedback.mentor1Name}
                                disabled={true}
                                className={errors.mentor1Name ? 'error' : ''} />
                            {errors.mentor1Name && <div className="error-text">{errors.mentor1Name}</div>}
                        </div>

                        <div className="formInput">
                            <label>Mentor2</label>
                            <input type="text"
                                name="mentor2Name"
                                value={feedback.mentor2Name}
                                disabled={true}
                                className={errors.mentor2Name ? 'error' : ''} />
                            {errors.mentor2Name && <div className="error-text">{errors.mentor2Name}</div>}
                        </div> */}

                          {/*  { !examinerId && 
                        
                         <div>
                        {feedback.folderLink && <a href={feedback.folderLink} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                            Folder Link
                            </a>}
                        {errors.folderLink && <div className="error-text">{errors.folderLink}</div>}
                        </div> 
                        } */}
                        <div className="formInput">
                       <h3 style={{ marginTop: "30px", textDecoration: "underline" }}> Submission for Evaluation </h3>
                        
                        <div >
    <strong>Report Type:</strong> {feedback.reportType}
    <span style={{ marginLeft: "20px" }}>
        <strong>Submission Type:</strong>{" "}
        {feedback.termType}
       {/* {statusLabelMap[feedback.termThesisStatus] || feedback.termThesisStatus} */}
    </span>
</div>


                       
                        <div>
                        {feedback.reportLink && isDriveLink(feedback.reportLink) && (
                                <div>
                                    <a href={feedback.reportLink} target="_blank" rel="noopener noreferrer">
                                        Report File
                                    </a>
                                </div>
                            )}
                            {errors.reportLink && <div className="error-text">{errors.reportLink}</div>}
                            {reportUploaded && !isDriveLink(feedback.reportLink) && fileLinks.Report?.url && (
                                <div>
                                    <a href={fileLinks.Report.url} target="_blank" rel="noopener noreferrer">
                                        Report File
                                    </a>
                                </div>
                            )}
                        </div>

                        <div>
                        {feedback.presentationLink && isDriveLink(feedback.presentationLink) && (
                                <div>
                                    <a href={feedback.presentationLink} target="_blank" rel="noopener noreferrer">
                                        Presetation File
                                    </a>
                                </div>
                            )}
                            {errors.presentationLink && <div className="error-text">{errors.presentationLink}</div>}
                            {presentationUploaded && !isDriveLink(feedback.presentationLink) && fileLinks.Presentation_File?.url && (
                                <div>
                                    <a href={fileLinks.Presentation_File.url} target="_blank" rel="noopener noreferrer">
                                        Presentation File
                                    </a>
                                </div>
                            )}
                        </div>

                        <div>
                        {feedback.presentationVideoLink && isDriveLink(feedback.presentationVideoLink) && (
                                <div>
                                    <a href={feedback.presentationVideoLink} target="_blank" rel="noopener noreferrer">
                                        Presentation Video
                                    </a>
                                </div>
                            )}
                            {errors.presentationVideoLink && <div className="error-text">{errors.presentationVideoLink}</div>}
                            {presentationVideoUploaded && !isDriveLink(feedback.presentationVideoLink) && fileLinks.Presentation_Video?.url && (
                                <div>
                                    <a href={fileLinks.Presentation_Video.url} target="_blank" rel="noopener noreferrer">
                                        Presentation Video
                                    </a>
                                </div>
                            )}
                        </div>

                        <div>
                        {feedback.codeDemoLink && isDriveLink(feedback.codeDemoLink) && (
                                <div>
                                    <a href={feedback.codeDemoLink} target="_blank" rel="noopener noreferrer">
                                        Code Demo File
                                    </a>
                                </div>
                            )}
                            {errors.codeDemoLink && <div className="error-text">{errors.codeDemoLink}</div>}
                            {codeDemoUploaded && !isDriveLink(feedback.codeDemoLink) && fileLinks.Code_Demo_File?.url && (
                                <div>
                                    <a href={fileLinks.Code_Demo_File.url} target="_blank" rel="noopener noreferrer">
                                        Code Demo File
                                    </a>
                                </div>
                            )}
                        </div>

                        <div>
                        {feedback.turnitin && isDriveLink(feedback.turnitin) && (
                                <div>
                                    <a href={feedback.turnitin} target="_blank" rel="noopener noreferrer">
                                        Turnitin File
                                    </a>
                                </div>
                            )}
                            {errors.turnitin && <div className="error-text">{errors.turnitin}</div>}
                            {turnitinUploaded && !isDriveLink(feedback.turnitin) && fileLinks.Turnitin?.url && (
                                <div>
                                    <a href={fileLinks.Turnitin.url} target="_blank" rel="noopener noreferrer">
                                        Turnitin
                                    </a>
                                </div>
                            )}
                        </div>

                            <div>
                        {feedback.rebuttalReportLink && isDriveLink(feedback.rebuttalReportLink) && (
                                <div>
                                    <a href={feedback.rebuttalReportLink} target="_blank" rel="noopener noreferrer">
                                        Rebuttal Report File
                                    </a>
                                </div>
                            )}
                            {errors.rebuttalReportLink && <div className="error-text">{errors.rebuttalReportLink}</div>}
                            {rebuttalUploaded && !isDriveLink(feedback.rebuttalReportLink) && fileLinks.Rebuttal_Report_File?.url && (
                                <div>
                                    <a href={fileLinks.Rebuttal_Report_File.url} target="_blank" rel="noopener noreferrer">
                                        Rebuttal Report File
                                    </a>
                                </div>
                            )}
                        </div>

                        <div>
                            {aiSummaryLink && (
                                <div>
                                    <a
                                    href={aiSummaryLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    >
                                    AI Reviewer Summary
                                    </a>
                                </div>
                                )}
                        </div>
                       
                        {examinerFeedbacks.length > 0 && (
                        <div className="examiner-feedback-section">
                            <h3 style={{ marginTop: "30px", textDecoration: "underline" }}>Previous Reports and Feedback</h3>
                            <div className="feedback-scroll">
                            {examinerFeedbacks
                           // .filter((exam) => exam.is_examiner && (exam.report_type !== feedback.type || (exam.report_type === feedback.type && exam.share_to_student==true))) 
                            .map((group, idx) => (
                                <div key={idx} className="examiner-card">
                                {/*<p><strong>{exam.report_type}</strong></p>
                                <p><strong>{exam.report_type}</strong> — {exam.term_type }</p> */}
                         <p>
<strong>{"Report Type"}</strong> : {group.report_type} <span style={{ marginLeft: "20px" }}></span><strong>{"Submission Type"}</strong> : {group.term_type}{" "}</p>
                        
                            <p> <strong>{"Evaluation Status"}</strong> : {" "}
                            {group.thesis_viva_status === null || group.thesis_viva_status === "WORK_IN_PROGRESS"
                                         ? "Resubmission is required for re-evaluation"
                              : group.thesis_viva_status === "REPORT_REVISION_REQUIRED"
                                          ? "Report revision required"
                              : group.thesis_viva_status === "RESUBMISSION"
                                          ? "Resubmission required for re-evaluation"
                              : group.thesis_viva_status === "PHASE_COMPLETED"
                                          ? "Report accepted"
                              
                                : group.thesis_viva_status}
                                            </p>
                             <strong>Report Link:</strong> <a href={group.report_link} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Report
                            </a>                

                                <h4>Feedback from Examiners:</h4>

                                     

                                    {group.feedbacks.map((exam, i) => (
                                <li style={{ listStyleType: "none" }} key={i} className="examiner-feedback">
                                 <h4><strong>Examiner {i+1}:</strong> </h4>
                                <ul>
                                
                                    {exam.report_feedback && (<li><strong>Feedback on Report:</strong> {exam.report_feedback || "—"}</li>)}
                                    {exam.presentation_feedback && (<li><strong>Feedback on Presentation:</strong> {exam.presentation_feedback || "—"}</li>)}
                                    {exam.overall_feedback&& (<li><strong>Overall Feedback:</strong> {exam.overall_feedback || "—"}</li>)}
                                   {/* <li><strong>Other Feedbacks (shared with admin only):</strong> {exam.other_feedback || "—"}</li> */}
                                </ul>
                               
                                </li>
                                    ))}
                                </div>
                            ))}
                            </div>
                        </div>
                        )}
                        


                        {!studentLoginId && !examinerId && <div className="formInput">
                            <label>Select Examiner/Reviewer</label>
                            <select id="styled-dropdown"
                                name="examiner"
                                value={selectedExaminerId}
                                onChange={handleAddExaminerSelect}
                                disabled={viewMode || editMode}
                            >
                                <option value="">Select examiner/reviewer</option>
                                {examiners && examiners.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.name},{option.email}
                                    </option>
                                ))}
                            </select>
                            {errors.examiner && <div className="error-text">{errors.examiner}</div>}
                        </div>
                        }

                      </div>
                       {/* <div className="formInput">
                            <label>Feedback type</label>
                            <select id="styled-dropdown"
                                name="type"
                                value={feedback.type}
                                onChange={handleChange}
                                disabled={viewMode || editMode}
                                className={errors.type ? 'error' : ''}>
                                <option value={feedback.type}>{feedback.type}</option>
                            </select>
                            {errors.type && <div className="error-text">{errors.type}</div>}
                        </div> */}
                        {feedback.type == "Monthly" && <div className="Monthly">
                              
                            {/* <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Introduction and Motivation : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        <ul>
                                        <li> Clearly states the research problem (max : 2.5 marks)</li>
                                        <li> Demonstrates an understanding of relevant background literature and makes a strong use case of the proposed problem (max : 2.5 marks)</li>
                                        <li> Identifies gaps and limitations in existing research (max : 2.5 marks)</li>
                                        <li> Provides a clear roadmap for the rest of the thesis (max : 2.5 marks)</li>

                                        </ul>
                                    
                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeIntroMotivation"
                                    disabled={viewMode}
                                    value={feedback.gradeIntroMotivation}
                                    className={errors.gradeIntroMotivation ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S (9-10)</option>
                                    <option value="A">A (8-9)</option>
                                    <option value="B">B (7-8)</option>
                                    <option value="C">C (6-7)</option>
                                    <option value="D">D (5-6)</option>
                                    <option value="E">E (4-5)</option>
                                </select>
                                {errors.gradeIntroMotivation && <div className="error-text">{errors.gradeIntroMotivation}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Comments on Introduction & Motivation</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="introMotivation"
                                    value={feedback.introMotivation}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.introMotivation ? 'error' : ''} />
                                {errors.introMotivation && <div className="error-text">{errors.introMotivation}</div>}
                            </div>


                            <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Problem Statement : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        <ul>
                                        <li> Clearly articulates the research problem (max: 2 marks)</li>
                                        <li> Defines the scope and boundaries of the study (max: 2 marks)</li>
                                        <li> Demonstrates the importance and relevance of the problem within the field (max: 2 marks)</li>
                                        <li> Demonstrates the feasibility of addressing the problem within the given constraints (max: 2 marks)</li>
                                        <li> Aligns with overall objectives and goals of the thesis (max: 2 marks)</li>

                                        </ul>
                                    
                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeProblemStmt"
                                    disabled={viewMode}
                                    value={feedback.gradeProblemStmt}
                                    className={errors.gradeProblemStmt ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S (9-10)</option>
                                    <option value="A">A (8-9)</option>
                                    <option value="B">B (7-8)</option>
                                    <option value="C">C (6-7)</option>
                                    <option value="D">D (5-6)</option>
                                    <option value="E">E (4-5)</option>
                                </select>
                                {errors.gradeProblemStmt && <div className="error-text">{errors.gradeProblemStmt}</div>}
                            </div>
                            <div className="monthlyInput">
                                <label>Comments on Problem Statement</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="problemStmt"
                                    value={feedback.problemStmt}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.problemStmt ? 'error' : ''} />
                                {errors.problemStmt && <div className="error-text">{errors.problemStmt}</div>}
                            </div>

                            <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Literature Survey </span>

                                    <span style={{ fontSize: '14px' }}>
                                        <ul>
                                        <li> Provides a coherent flow of ideas highlighting the gaps in literature and mentioning the contribution of the thesis in light of the gaps in the literature (max: 2.5 marks)</li>
                                        <li> Incorporates recent and up-to-date sources (max: 2.5 marks)</li>
                                        <li> Provides clear citations and references (max: 2.5 marks)</li>
                                        <li> Highlights the relevance of existing literature to the current study (max: 2.5 marks)</li>

                                        </ul>
                                    
                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeLiteratureSurvey"
                                    disabled={viewMode}
                                    value={feedback.gradeLiteratureSurvey}
                                    className={errors.gradeLiteratureSurvey ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S (9-10)</option>
                                    <option value="A">A (8-9)</option>
                                    <option value="B">B (7-8)</option>
                                    <option value="C">C (6-7)</option>
                                    <option value="D">D (5-6)</option>
                                    <option value="E">E (4-5)</option>
                                </select>
                                {errors.gradeLiteratureSurvey && <div className="error-text">{errors.gradeLiteratureSurvey}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Comments on Literature Survey</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="literatureSurvey"
                                    value={feedback.literatureSurvey}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.literatureSurvey ? 'error' : ''} />
                                {errors.literatureSurvey && <div className="error-text">{errors.literatureSurvey}</div>}
                            </div>

                            <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Methodology </span>

                                    <span style={{ fontSize: '14px' }}>
                                        <ul>
                                        <li>  Clearly outlines the methodology (max: 2 marks)</li>
                                        <li> Provides rationale for chosen methodology (max: 2 marks)</li>
                                        <li> Demonstrates alignment between research questions and chosen methods (max: 2 marks)</li>
                                        <li>Describes data clearly and concisely (max: 2 marks)</li>
                                        <li> Provides clear steps for data analysis and model building (max: 2 marks)</li>

                                        </ul>
                                    
                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeMethodology"
                                    disabled={viewMode}
                                    value={feedback.gradeMethodology}
                                    className={errors.gradeMethodology ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S (9-10)</option>
                                    <option value="A">A (8-9)</option>
                                    <option value="B">B (7-8)</option>
                                    <option value="C">C (6-7)</option>
                                    <option value="D">D (5-6)</option>
                                    <option value="E">E (4-5)</option>
                                </select>
                                {errors.gradeMethodology && <div className="error-text">{errors.gradeMethodology}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Comments on Methodology</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="methodology"
                                    value={feedback.methodology}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.methodology ? 'error' : ''} />
                                {errors.methodology && <div className="error-text">{errors.methodology}</div>}
                            </div>

                            <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Results </span>

                                    <span style={{ fontSize: '14px' }}>
                                        <ul>
                                        <li>  Presents results clearly and concisely (max: 2 marks)</li>
                                        <li>  Utilizes appropriate tables, figures or graphs to illustrate findings (max: 2 marks)</li>
                                        <li> Provides thoughtful interpretation of results (max: 2 marks)</li>
                                        <li>Relates findings back to research questions or objectives (max: 2 marks)</li>
                                        <li>Ensures consistency between results and methodology (max: 2 marks)</li>

                                        </ul>
                                    
                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeResults"
                                    disabled={viewMode}
                                    value={feedback.gradeResults}
                                    className={errors.gradeResults ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S (9-10)</option>
                                    <option value="A">A (8-9)</option>
                                    <option value="B">B (7-8)</option>
                                    <option value="C">C (6-7)</option>
                                    <option value="D">D (5-6)</option>
                                    <option value="E">E (4-5)</option>
                                </select>
                                {errors.gradeResults && <div className="error-text">{errors.gradeResults}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Comments on Results</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="results"
                                    value={feedback.results}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.results ? 'error' : ''} />
                                {errors.results && <div className="error-text">{errors.results}</div>}
                            </div>
                            <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Conclusion and Future Work
                                    </span>

                                    <span style={{ fontSize: '14px' }}>
                                        <ul>
                                        <li> Summarizes key findings and contributions of the thesis (max: 4 marks)</li>
                                        <li> Acknowledges limitations and constraints of the study (max: 2 marks)</li>
                                        <li> Identifies areas for future research (max: 4 marks)</li>

                                        </ul>
                                    
                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeConclusionFuturework"
                                    disabled={viewMode}
                                    value={feedback.gradeConclusionFuturework}
                                    className={errors.gradeConclusionFuturework ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S (9-10)</option>
                                    <option value="A">A (8-9)</option>
                                    <option value="B">B (7-8)</option>
                                    <option value="C">C (6-7)</option>
                                    <option value="D">D (5-6)</option>
                                    <option value="E">E (4-5)</option>
                                </select>
                                {errors.gradeConclusionFuturework && <div className="error-text">{errors.gradeConclusionFuturework}</div>}
                            </div>


                            <div className="monthlyInput">
                                <label>Comments on Conclusion & Future Work</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="conclusionFuturework"
                                    value={feedback.conclusionFuturework}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.conclusionFuturework ? 'error' : ''} />
                                {errors.conclusionFuturework && <div className="error-text">{errors.conclusionFuturework}</div>}
                            </div>


                            <div className="monthlyInput">
                                <label>Comments on Presentation</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="presentation"
                                    value={feedback.presentation}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.presentation ? 'error' : ''} />
                                {errors.presentation && <div className="error-text">{errors.presentation}</div>}
                            </div> */}
                            
                            {!studentLoginId && userRole != "ROLE_REVIEWER" &&<div className="monthlyInput">
                                <h3 style={{ marginTop: "30px", textDecoration: "underline" }}>
            Feedback Form
        </h3>

                                <label>
                                    Marks on Report (Max. 30)  : 
                                    <span
                                    style={{ marginLeft: 4, cursor: 'pointer' }}
                                    title={`
                                    The points to be considered in the evaluation of report are:
                                    - Formatting of report
                                    - Motivation and Background literature
                                    - Outline of Methods or Approach
                                    - Dataset Understanding and EDA
                                    - Presentation of Objectives
                                    - Results presentation and Discussion
                                    - Conclusion and Future Work`}
                                    >
                                    ℹ️
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    name="reportMarks"
                                    value={feedback.reportMarks}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    required={userRole==="ROLE_EXAMINER"}
                                    min="0"
                                    max="30"
                                    className={errors.reportMarks ? 'error' : ''}
                                    style={{ width: '6rem' }}
                                />

                                {errors.reportMarks && <div className="error-text">{errors.reportMarks}</div>}
                                </div>}

                            {!studentLoginId && userRole != "ROLE_REVIEWER" &&<div className="monthlyInput">
                                <label>
                                    Marks on Presentation (Max. 20)  :
                                    <span
                                    style={{ marginLeft: 4, cursor: 'pointer' }}
                                    title={`
                                    The points to be considered in the evalaution of presentation are as follows:
                                    -Clarity and coherence of the content
                                    -Clarity of Presentation (Well-paced, Communicated - -ideas, objectives & results well)
                                    -Completion of the presentation within the allotted time frame
                                    -All materials presented are relevant and lead naturally to the conclusion/recommendation`}
                                    >
                                    ℹ️
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    name="presentationMarks"
                                    value={feedback.presentationMarks}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    required={userRole==="ROLE_EXAMINER"}
                                    min="0"
                                    max="20"
                                    className={errors.presentationMarks ? 'error' : ''}
                                    style={{ width: '6rem' }}
                                />

                                {errors.presentationMarks && <div className="error-text">{errors.presentationMarks}</div>}
                                </div>}


                            {!studentLoginId && userRole != "ROLE_REVIEWER" &&<div className="monthlyInput">
                                <label>
                                    Marks on Questions & Answers and  Novelty & Quality of work (Max. 50)  : 
                                    <span
                                    style={{ marginLeft: 4, cursor: 'pointer' }}
                                    title={`
                                    The points to be considered in the evalaution  of viva and work are as follows:
                                    -Able to address the questions posed by the committee
                                    -Able to use slides to answer the questions posed by the committee
                                    -Able to answer questions to the point and correctly
                                    -Understanding of fundamentals of the subject
                                    -Results presentation and Discussion
                                    -Novelty, Quality, Correctness of Methodology etc in the work`}
                                    >
                                    ℹ️
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    name="vivaMarks"
                                    value={feedback.vivaMarks}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    required={userRole==="ROLE_EXAMINER"}
                                    min="0"
                                    max="50"
                                    className={errors.vivaMarks ? 'error' : ''}
                                    style={{ width: '6rem' }}
                                />

                                {errors.vivaMarks && <div className="error-text">{errors.vivaMarks}</div>}
                                </div>}


                            <div className="monthlyInput">
                                <label>Feedback on Presentation</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="presentationFeedback"
                                    value={feedback.presentationFeedback}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.presentationFeedback ? 'error' : ''} />
                                {errors.presentationFeedback && <div className="error-text">{errors.presentationFeedback}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Feedback on Report</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="reportFeedback"
                                    value={feedback.reportFeedback}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.feedback ? 'error' : ''} />
                                {errors.feedback && <div className="error-text">{errors.feedback}</div>}
                            </div>

                            {!studentLoginId &&<div className="monthlyInput">
                                <label>Other Feedbacks (shared with admin only)</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="otherFeedback"
                                    value={feedback.otherFeedback}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.otherFeedback ? 'error' : ''} />
                                {errors.otherFeedback && <div className="error-text">{errors.otherFeedback}</div>}
                            </div>}

                            <div className="monthlyInput">
                                <label>Overall Feedbacks</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="overallFeedback"
                                    value={feedback.overallFeedback}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.overallFeedback ? 'error' : ''} />
                                {errors.overallFeedback && <div className="error-text">{errors.overallFeedback}</div>}
                            </div>
                        </div>
                        }


                        {(feedback.type == "Phase1" || feedback.type == "Phase2" || feedback.type == "Phase3") && <div className="Monthly">
                            <br/>
                            {/* <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Strong Use Case for the Proposed Problem : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        This criterion evaluates how effectively the student has identified and articulated the relevance and significance of the problem, including problem identification, rationale, and contextual understanding.

                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeProposedProblem"
                                    disabled={viewMode}
                                    value={feedback.gradeProposedProblem}
                                    className={errors.gradeProposedProblem ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeProposedProblem && <div className="error-text">{errors.gradeProposedProblem}</div>}
                            </div>

                            <br/>
                            <div className="examinerGrade">
                                <label >
                                    <span style={{ fontSize: '17px' }}> Strong Use Case for the Proposed Solution : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        This criterion evaluates how effectively the student has proposed a viable solution to the identified problem, considering the viability of the approach, technical feasibility, data requirements, and creativity and uniqueness.

                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeProposedSolution"
                                    disabled={viewMode}
                                    value={feedback.gradeProposedSolution}
                                    className={errors.gradeProposedSolution ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeProposedSolution && <div className="error-text">{errors.gradeProposedSolution}</div>}
                            </div>

                            <br/>
                            <div className="examinerGrade">
                                <label >
                                    <span style={{ fontSize: '17px' }}> Conceptual Clarity and Understanding of the Problem : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        This criterion evaluates how well the student demonstrates a clear and deep understanding of the problem, including problem definition, contextual understanding, identification of key issues, analytical depth, and articulation and clarity.
                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeProblemUnderstanding"
                                    disabled={viewMode}
                                    value={feedback.gradeProblemUnderstanding}
                                    className={errors.gradeProblemUnderstanding ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeProblemUnderstanding && <div className="error-text">{errors.gradeProblemUnderstanding}</div>}
                            </div>

                            <br/>
                            <div className="examinerGrade">
                                <label >
                                    <span style={{ fontSize: '17px' }}> Academic Rigour in the Solution Procedure  : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        This criterion evaluates the thoroughness, precision, and scholarly approach the student has employed in developing and presenting their solution.
                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeAcademicRigour"
                                    disabled={viewMode}
                                    value={feedback.gradeAcademicRigour}
                                    className={errors.gradeAcademicRigour ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeAcademicRigour && <div className="error-text">{errors.gradeAcademicRigour}</div>}
                            </div>

                            <br/>

                            <div className="examinerGrade">
                                <label >
                                    <span style={{ fontSize: '17px' }}>
                                        Quantum of Work   : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        This criterion assesses the overall amount and depth of work completed during the master's thesis, including research effort, data analysis, model selection, and the results and outputs produced.
                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeWorkQuantum"
                                    disabled={viewMode}
                                    value={feedback.gradeWorkQuantum}
                                    className={errors.gradeWorkQuantum ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeWorkQuantum && <div className="error-text">{errors.gradeWorkQuantum}</div>}
                            </div>
                            <br/> */}

                            {!studentLoginId && userRole != "ROLE_REVIEWER" &&<div className="monthlyInput">
                                <h3 style={{ marginTop: "30px", textDecoration: "underline" }}>
            Feedback Form
        </h3>
                                <label>
                                    Marks on Report (Max. 30)  : 
                                    <span
                                    style={{ marginLeft: 4, cursor: 'pointer' }}
                                    title="
                                    The points to be considered in the evaluation of report are:
                                    - Formatting of report
                                    - Motivation and Background literature
                                    - Outline of Methods or Approach
                                    - Dataset Understanding and EDA
                                    - Presentation of Objectives
                                    - Results presentation and Discussion
                                    - Conclusion and Future Work"
                                    >
                                    ℹ️
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    name="reportMarks"
                                    value={feedback.reportMarks}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    required={userRole==="ROLE_EXAMINER"}
                                    min="0"
                                    max="30"
                                    className={errors.reportMarks ? 'error' : ''}
                                    style={{ width: '6rem' }}
                                />

                                {errors.reportMarks && <div className="error-text">{errors.reportMarks}</div>}
                                </div>}

                            {!studentLoginId && userRole != "ROLE_REVIEWER" &&<div className="monthlyInput">
                                <label>
                                    Marks on Presentation (Max. 20)  :
                                    <span
                                    style={{ marginLeft: 4, cursor: 'pointer' }}
                                    title="
                                    The points to be considered in the evalaution of presentation are as follows:
                                    -Clarity and coherence of the content
                                    -Clarity of Presentation (Well-paced, Communicated - -ideas, objectives & results well)
                                    -Completion of the presentation within the allotted time frame
                                    -All materials presented are relevant and lead naturally to the conclusion/recommendation"
                                    >
                                    ℹ️
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    name="presentationMarks"
                                    value={feedback.presentationMarks}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    required={userRole==="ROLE_EXAMINER"}
                                    min="0"
                                    max="20"
                                    className={errors.presentationMarks ? 'error' : ''}
                                    style={{ width: '6rem' }}
                                />

                                {errors.presentationMarks && <div className="error-text">{errors.presentationMarks}</div>}
                                </div>}


                            {!studentLoginId && userRole != "ROLE_REVIEWER" &&<div className="monthlyInput">
                                <label>
                                    Marks on Questions & Answers and  Novelty & Quality of work (Max. 50)  : 
                                    <span
                                    style={{ marginLeft: 4, cursor: 'pointer' }}
                                    title="
                                    The points to be considered in the evalaution  of viva and work are as follows:
                                    -Able to address the questions posed by the committee
                                    -Able to use slides to answer the questions posed by the committee
                                    -Able to answer questions to the point and correctly
                                    -Understanding of fundamentals of the subject
                                    -Results presentation and Discussion
                                    -Novelty, Quality, Correctness of Methodology etc in the work"
                                    >
                                    ℹ️
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    name="vivaMarks"
                                    value={feedback.vivaMarks}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    required={userRole==="ROLE_EXAMINER"}
                                    min="0"
                                    max="50"
                                    className={errors.vivaMarks ? 'error' : ''}
                                    style={{ width: '6rem' }}
                                />

                                {errors.vivaMarks && <div className="error-text">{errors.vivaMarks}</div>}
                                </div>}

                            {userRole != "ROLE_REVIEWER" && <div className="examinerGrade">
                                <label>Overall Grade </label>
                                <select onChange={handleChange}
                                    name="gradeOverall"
                                    disabled={viewMode}
                                    value={feedback.gradeOverall}
                                    required={userRole==="ROLE_EXAMINER"}
                                    className={errors.gradeOverall ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S</option>
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                    <option value="D">D</option>
                                    <option value="E">E</option>
                                    <option value="U">U</option>
                                    <option value="I">I</option>
                                </select>
                                {errors.gradeOverall && <div className="error-text">{errors.gradeOverall}</div>}
                            </div>}

                            <br/>
                            <div className="monthlyInput">
                                <label>Feedback on Presentation</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="presentationFeedback"
                                    value={feedback.presentationFeedback}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.presentationFeedback ? 'error' : ''} />
                                {errors.presentationFeedback && <div className="error-text">{errors.presentationFeedback}</div>}
                            </div>
                            <br/>

                            <div className="monthlyInput">
                                <label>Feedback on Report</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="reportFeedback"
                                    value={feedback.reportFeedback}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.reportFeedback ? 'error' : ''} />
                                {errors.reportFeedback && <div className="error-text">{errors.reportFeedback}</div>}
                            </div>
                            <br/>

                            {!studentLoginId &&<div className="monthlyInput">
                                <label>Other Feedbacks (shared with admin only)</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="otherFeedback"
                                    value={feedback.otherFeedback}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.otherFeedback ? 'error' : ''} />
                                {errors.otherFeedback && <div className="error-text">{errors.otherFeedback}</div>}
                            </div>}
                            <br/>
                            
                            <div className="monthlyInput">
                                <label>Overall Feedbacks</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="overallFeedback"
                                    value={feedback.overallFeedback}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.overallFeedback ? 'error' : ''} />
                                {errors.overallFeedback && <div className="error-text">{errors.overallFeedback}</div>}
                            </div>
                        </div>

                        }
                            

                            {/* <div className="formInput">
                                <label>Is the problem mentioned in the problem statement solved?</label>
                                <input type="text"
                                    name="problemSolved"
                                    value={feedback.problemSolved}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.problemSolved ? 'error' : ''} />
                                {errors.problemSolved && <div className="error-text">{errors.problemSolved}</div>}
                            </div> */}
                        
                        {(feedback.type == "ProjectProposal") && <div className="Monthly">
                            <h3 style={{ marginTop: "30px", textDecoration: "underline" }}>
            Feedback Form
        </h3>
                            <div className="monthlyInput">
                                <label>Feedback on Presentation</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="presentationFeedback"
                                    value={feedback.presentationFeedback}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.presentationFeedback ? 'error' : ''} />
                                {errors.presentationFeedback && <div className="error-text">{errors.presentationFeedback}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Feedback on Report</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="reportFeedback"
                                    value={feedback.reportFeedback}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.reportFeedback ? 'error' : ''} />
                                {errors.reportFeedback && <div className="error-text">{errors.reportFeedback}</div>}
                            </div>

                            {!studentLoginId &&<div className="monthlyInput">
                                <label>Other Feedbacks (shared with admin only)</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="otherFeedback"
                                    value={feedback.otherFeedback}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.otherFeedback ? 'error' : ''} />
                                {errors.otherFeedback && <div className="error-text">{errors.otherFeedback}</div>}
                            </div>}

                            <div className="monthlyInput">
                                <label>Overall Feedbacks</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="overallFeedback"
                                    value={feedback.overallFeedback}
                                    readOnly={viewMode}
                                    onChange={handleChange}
                                    className={errors.overallFeedback ? 'error' : ''} />
                                {errors.overallFeedback && <div className="error-text">{errors.overallFeedback}</div>}
                            </div>


                        </div>

                        }
                        <div className="buttons">
                            {!viewMode && <button type="submit">{editMode ? 'Update' : 'Save'}</button>}
                          {/*  <button onClick={goBack}>Back</button> */}
                            <button onClick={() => navigate(from)}>
  Back
</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};
